export default __webpack_public_path__ + "static/media/NEW_JGG_LOGO.2ef66865.png";